// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","container":"App_container__4L7Vo"};